"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _async = _interopRequireDefault(require("react-select/async"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _themeUi = require("theme-ui");

var _withValidation = _interopRequireDefault(require("../../lib/withValidation"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FauxInput = function FauxInput(props, ref) {
  return (0, _themeUi.jsx)("input", _extends({
    ref: ref
  }, props));
};

var FauxValidatedInput = (0, _withValidation["default"])((0, _react.forwardRef)(FauxInput));

var SelectEnhanced = function SelectEnhanced(_ref) {
  var id = _ref.id,
      Component = _ref.as,
      name = _ref.name,
      _onChange = _ref.onChange,
      validationMessage = _ref.validationMessage,
      disabled = _ref.disabled,
      isMulti = _ref.isMulti,
      styles = _ref.styles,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "as", "name", "onChange", "validationMessage", "disabled", "isMulti", "styles"]);

  var _useThemeUI = (0, _themeUi.useThemeUI)(),
      theme = _useThemeUI.theme;

  var inputStyles = (0, _themeUi.css)(theme.forms.input)(theme);
  var inputRef = (0, _react.useRef)();
  var isInvalid = !!validationMessage;
  return (0, _themeUi.jsx)(_react["default"].Fragment, null, (0, _themeUi.jsx)(Component, _extends({
    id: id,
    isDisabled: disabled,
    isMulti: isMulti,
    onChange: function onChange(value) {
      return _onChange({
        currentTarget: {
          value: value,
          name: name || id
        }
      });
    },
    openMenuOnFocus: isInvalid,
    onFocus: function onFocus() {
      inputRef.current.reportValidity();
    },
    styles: {
      container: function container(provided) {
        return _extends({}, provided, (0, _themeUi.css)(_extends({
          display: 'flex',
          flexDirection: 'column'
        }, !!styles && styles.container))(theme));
      },
      valueContainer: function valueContainer(provided) {
        return _extends({}, provided, (0, _themeUi.css)(_extends({
          pl: isMulti ? 1 : 3,
          py: 1
        }, !!styles && styles.valueContainer))(theme));
      },
      control: function control(provided, state) {
        return _extends({}, provided, (0, _themeUi.css)(_extends({
          variant: theme.forms.input.variant,
          minHeight: 5,
          color: inputStyles.color,
          borderColor: inputStyles.borderColor,
          cursor: disabled ? 'default' : 'pointer',
          '&:hover': {
            boxShadow: 'none'
          }
        }, state.isFocused && _extends({}, inputStyles[':focus'], {
          '&:hover': inputStyles[':focus']
        }), state.isDisabled && inputStyles[':disabled'], isInvalid && inputStyles[':invalid'], !!styles && (typeof styles.control === 'function' ? styles.control(provided, state) : styles.control)))(theme));
      },
      option: function option(provided, state) {
        return _extends({}, provided, (0, _themeUi.css)(_extends({
          px: 3,
          cursor: state.isDisabled ? 'default' : 'pointer',
          backgroundColor: state.isDisabled ? null : state.isSelected ? 'primaryLight' : state.isFocused ? 'primaryLightHover' : null,
          color: state.isDisabled ? 'textDisabled' : state.isSelected ? 'textWhite' : 'text'
        }, !!styles && styles.option))(theme), {
          '&:active': _extends({}, provided[':active'], (0, _themeUi.css)({
            backgroundColor: 'primaryLightHover'
          })(theme))
        });
      },
      input: function input(provided) {
        return _extends({}, provided, (0, _themeUi.css)(_extends({
          variant: theme.forms.input.variant,
          pl: isMulti ? 2 : 0,
          ml: isMulti ? 1 : 0
        }, !!styles && styles.input))(theme));
      },
      dropdownIndicator: function dropdownIndicator(provided) {
        return _extends({}, provided, (0, _themeUi.css)(_extends({
          color: 'text',
          '&:hover': {
            color: 'text'
          }
        }, !!styles && styles.dropdownIndicator))(theme));
      },
      placeholder: function placeholder(provided) {
        return _extends({}, provided, inputStyles['::placeholder'], (0, _themeUi.css)(_extends({
          pl: isMulti ? 2 : 0,
          ml: isMulti ? 1 : 0
        }, !!styles && styles.placeholder))(theme));
      },
      multiValue: function multiValue(provided, state) {
        return _extends({}, provided, (0, _themeUi.css)(_extends({
          m: 1,
          bg: state.data.isError ? 'alerts.error' : 'alerts.informationLight',
          '& > div': _extends({}, theme.textStyles.caption, {
            p: 2,
            color: state.data.isError ? 'textWhite' : 'alerts.information',
            ':first-of-type': {
              pr: 0
            },
            ':last-child': {
              px: 1,
              '&:hover': {
                color: 'alerts.error'
              }
            }
          })
        }, !!styles && styles.multiValue))(theme));
      }
    }
  }, props)), (0, _themeUi.jsx)(FauxValidatedInput, {
    ref: inputRef,
    validationMessage: validationMessage,
    sx: {
      position: 'absolute',
      opacity: 0,
      height: 0,
      width: '100%'
    }
  }));
};

SelectEnhanced.propTypes = {
  as: _propTypes["default"].oneOf([_reactSelect["default"], _creatable["default"], _async["default"]])
};
SelectEnhanced.defaultProps = {
  as: _reactSelect["default"]
};
var _default = SelectEnhanced;
exports["default"] = _default;